// Top-level dealer info: name, type, contact. This section writes to the
// top-level PATCH /dealers/{id} endpoint — NOT to the config PATCH.
import React from 'react';
import { TextField, SelectField } from './fields';

const TYPE_OPTIONS = [
  { value: 'local_retail', label: 'Local retail' },
  { value: 'broker_remote', label: 'Broker / remote' },
];

export default function ProfileSection({ dealer, onChange }) {
  const set = (key) => (v) => onChange({ ...dealer, [key]: v });
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <TextField label="Dealer name" value={dealer.name} onChange={set('name')} />
      <SelectField
        label="Dealer type"
        value={dealer.dealer_type}
        onChange={set('dealer_type')}
        options={TYPE_OPTIONS}
      />
      <TextField
        label="Primary contact name"
        value={dealer.primary_contact_name}
        onChange={set('primary_contact_name')}
      />
      <TextField
        label="Primary contact email"
        type="email"
        value={dealer.primary_contact_email}
        onChange={set('primary_contact_email')}
      />
      <TextField
        label="Primary phone"
        value={dealer.primary_phone}
        onChange={set('primary_phone')}
        placeholder="+1 555 000 0000"
      />
    </div>
  );
}
